export default __webpack_public_path__ + "static/media/7.ef97fae7.jpg";